import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_API_URL, {
  withCredentials: true,
  autoConnect: false,
});

// Add error listeners for debugging
socket.on("connect", () => {
  console.log("✅ Socket connected successfully!", socket.id);
});

socket.on("connect_error", (error) => {
  console.error("❌ Socket connection error:", error.message);
  console.error("Full error:", error);
});

socket.on("disconnect", (reason) => {
  console.warn("⚠️ Socket disconnected:", reason);
});

// Add token authentication when connecting
const connectWithToken = (token) => {
  socket.auth = { token };
  socket.connect();
};

const disconnect = () => {
  socket.disconnect();
};

export { socket, connectWithToken, disconnect };